import Wix from './wix-sdk-polyfill';
import { getLanguage } from './i18n-utils';

export default function requestLogin(cb) {
  return Wix.requestLogin(
    {
      language: getLanguage(),
      checkCommunityCheckbox: true,
    },
    member => {
      if (member && member.authResponse) {
        member = member.data;
      }
      cb(member);
    }
  );
}



// WEBPACK FOOTER //
// ./app/services/request-login.js